import {DRAFT_VERSION, type PersistedDraftEnvelope} from "./serialize-draft";

export function deserializeDraft<T>(raw: string | null, fallback: T): T {
  if (!raw) {
    return fallback;
  }

  try {
    const parsed = JSON.parse(raw) as PersistedDraftEnvelope<T> | T;

    if (
      parsed &&
      typeof parsed === "object" &&
      "draftVersion" in parsed &&
      "state" in parsed
    ) {
      const envelope = parsed as PersistedDraftEnvelope<T>;
      if (envelope.draftVersion !== DRAFT_VERSION) {
        return fallback;
      }
      return envelope.state ?? fallback;
    }

    return parsed as T;
  } catch {
    return fallback;
  }
}
